import React from "react"
import { Link } from "gatsby"
import uuid from "uuid"
import Navbar from "react-bootstrap/Navbar"
import Nav from "react-bootstrap/Nav"
import NavDropdown from "react-bootstrap/NavDropdown"
import pageLinksData from "./pageLinksData"
import Logo from "@images/logo.png"
import { OutboundLink } from "@assertiv/assertiv-gatsby-plugin-google-gtag"

import Wrapper from "@components/Wrapper"
import styles from "./EngineIDNavBar.module.scss"

const NavbarContents = props => {
  return (
    <Navbar
      id="engineid-navbar"
      expand="xl"
      className={"justify-content-end justify-content-xl-between"}
      fixed="top"
    >
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse className="justify-content-end">
        <Nav
          id="engineid-navbar-nav"
          className={
            "text-primary w-100 justify-content-xl-between text-center"
          }
        >
          {pageLinksData.map(pageLinkData => {
            if (pageLinkData.type === "dropdown") {
              const links = [];
              pageLinkData.items.map(item => {
                if ( item.href.startsWith("https://") || item.href.startsWith("http://") ) {
                  links.push(<OutboundLink
                    className={"dropdown-item proxima-nova--semi-bold fs-14pt ls-1px text-center"}
                    activeClassName="active"
                    key={uuid()}
                    target="_blank"
                    href={item.href}
                  >
                    {item.innerHTML}
                  </OutboundLink>)
                } else {
                  links.push(
                    <Link
                      key={uuid()}
                      to={item.href}
                      className={`dropdown-item proxima-nova--semi-bold fs-14pt ls-1px text-center`}
                      activeClassName="active"
                    >
                      {item.innerHTML}
                    </Link>
                  );
                }
              });
              return (
                <NavDropdown
                  key={uuid()}
                  title={pageLinkData.innerHTML}
                  className={`proxima-nova--semi-bold fs-14pt ls-1px`}
                  activeClassName="active"
                >
                  {links}
                </NavDropdown>
              )
            }
            // use regular a tag for sign in
            if ( pageLinkData.href.startsWith("http://") || pageLinkData.href.startsWith("https://app.engineid.com") || pageLinkData.href.startsWith("https://blog.engineid.com") ) {
              return (<OutboundLink
                className={"nav-link proxima-nova--semi-bold fs-14pt ls-1px"}
                key={uuid()}
                target="_blank"
                href={pageLinkData.href}
                activeClassName="active"
              >
                {pageLinkData.innerHTML}
              </OutboundLink>)
            }

            return ( 
              <Link
                className={"nav-link proxima-nova--semi-bold fs-14pt ls-1px"}
                key={uuid()}
                to={pageLinkData.href}
                activeClassName="active"
              >
                {pageLinkData.innerHTML}
              </Link>
            )
          })}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

const EngineIDNavBar = props => {
  return (
    <section className={"container-fluid " + styles.splitBg}>
        <div className="row maxWidth">
          <Wrapper
            className="col-12 col-lg-6 bg-primary pr-lg-0 d-flex justify-content-end flex-column"
            placement="left"
          >
            <Link to="/" className={styles.logo}>
              <img src={Logo} className="w-100" alt="EngineID Logo" />
            </Link>
          </Wrapper>
          <Wrapper
            className={
              styles.rightWrapper +
              " col-12 col-lg-6 pl-lg-0 d-flex justify-content-end flex-column"
            }
            placement="right"
          >
            <NavbarContents></NavbarContents>
          </Wrapper>
        </div>
    </section>
  )
}

export default EngineIDNavBar
